// extracted by mini-css-extract-plugin
module.exports = {"responsive-image":"C263_ResponsiveImage_responsive-image__Sumk_"};